/* global $ */

export class EmailControl {
	constructor(el) {
		// allow optional separate form actions depending on radio button selected -- not being used currently
		// $('input[type=radio]').each(function () {
		// 	$(this).on('change', function () {
		// 		if ($(this).data('action') !== undefined) {
		// 			$(this).closest('form').attr('action', $(this).data('action'))
		// 		}
		// 	})
		// })

		this.$form = $(el)
		this.$button = this.$form.find('button[type="submit"]')
		this.$msg = this.$form.find('.message')

		// handle submit via ajax
		this.$form.on('submit', (e) => {
			this.$msg.html('&nbsp;')

			e.preventDefault()
			$.ajax({
				// dataType: "json",
				url: this.$form.attr('action'),
				type: this.$form.attr('method'),
				data: this.$form.serialize(),
			})
				.done(() => {
					this.$msg.removeClass('error')

					// hide button
					this.$button.hide()

					// show message
					this.$msg.html('THANK YOU FOR SIGNING UP!').addClass('show')
				})
				.fail(() => {
					this.$msg.addClass('error show')
					this.$msg.html(this.$form.data('server-error'))
				})
		})
	}
}
